import { render } from "./CodeEditor.vue?vue&type=template&id=45ee1cd3"
import script from "./CodeEditor.vue?vue&type=script&lang=js"
export * from "./CodeEditor.vue?vue&type=script&lang=js"

import "./CodeEditor.vue?vue&type=style&index=0&id=45ee1cd3&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.3.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__